import { useNavigate } from "react-router-dom";
import { ModalComponent } from "..";
import { SingleCooperativeMember } from "../../../redux/features/cooperative/cooperative.type";

export const AwaitingMembershipApprovalModal = ({
  modalOpen,
  onModalClose = () => {},
  memberDetails,
}: {
  modalOpen: boolean;
  onModalClose: () => void;
  memberDetails: SingleCooperativeMember;
}) => {
  const navigate = useNavigate();

  return (
    <ModalComponent
      isModalOpen={modalOpen}
      onModalClose={onModalClose}
      title={undefined}
      subTitle={undefined}
      childrenClassName="flex flex-col items-center justify-center"
      modalClassName=""
      hasButtons={!memberDetails.hasPaid && memberDetails.isPaymentRequired}
      proceedButtonText="Pay membership fee"
      onProceedClick={() => {
        navigate(
          `/app/cooperative/${encodeURIComponent(
            memberDetails.Cooperative?.CoopName
          )}/${memberDetails.Cooperative?.id}/join`
        );
      }}
      hasCancelButton={false}
      onCancelClick={() => {}}
      isLoading={false}
      isProceedDisabled={memberDetails.hasPaid}
    >
      <img src={"/assets/images/awaiting.svg"} alt="awaiting" className="" />
      <div className="text-center mt-4 text-[20px] font-bold">
        {!memberDetails.hasPaid && memberDetails.isPaymentRequired
          ? "Awaiting Payment"
          : "Awaiting Approval"}
      </div>
      <div className="text-center mt-1 opacity-80 text-sm">
        You will be able to view this cooperative once{" "}
        {!memberDetails.hasPaid &&
          memberDetails.isPaymentRequired &&
          "you pay your membership fee and "}{" "}
        your membership is approved.
      </div>
    </ModalComponent>
  );
};
